import { Component, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-toolbar',
  standalone: true,
  imports: [],
  templateUrl: './toolbar.component.html',
})
export class ToolbarComponent {
  /** El hamburger (solo visible en móvil) abre/cierra el drawer del shell. */
  @Output() menu = new EventEmitter<void>();

  constructor(private readonly router: Router) {}

  onClickGoToMainPage(): void {
    localStorage.removeItem('formulario');
    this.router.navigate(['/']);
  }
}
